import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { applyStoredTheme } from '@aaimplatform/ui/styles';
import App from './App';

// Import institutional design system styles
import './styles/tailwind.css';

/**
 * Pre-paint theme bootstrap (GH #2305). Applies the operator's stored
 * `aaim-theme` preference -- or `prefers-color-scheme` when none is stored --
 * to `documentElement` SYNCHRONOUSLY, before createRoot renders and before the
 * browser paints its first frame. This is the flash-of-wrong-theme guard: the
 * `dark` class must already be on the root when the first paint resolves the
 * `--color-*` custom properties. The ThemeToggle in the header only reconciles
 * its own glyph after mount.
 */
applyStoredTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
